import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'processArea',
    header: 'Process Area',
    type: 'text',
    width: 30,
  },
  {
    key: 'replacementTime',
    header: 'Replacement Time (Months)',
    type: 'number',
    width: 30,
  },
  {
    key: 'replacementCost',
    header: 'Replacement Cost (USD)',
    type: 'money',
  },
  {
    key: 'underlyingProcesses',
    header: 'Underlying Processes',
    type: 'number',
  },
];
